import {
  FRAME_INCREMENT_SIZE_25_FPS,
  TrimmableRegion,
} from "./components/audio-trimmer/audio-trimmer";

export const ensureRegionIncrementSize = (regions: TrimmableRegion[]) => {
  return regions.reduce((memo, region, index) => {
    const isLastItem = index === regions.length - 1;
    if (index === 0) {
      const endMs = isLastItem
        ? region.endMs
        : Math.round(region.endMs / FRAME_INCREMENT_SIZE_25_FPS) * FRAME_INCREMENT_SIZE_25_FPS;
      // this could possibly not be zero
      const startMs =
        Math.round(region.startMs / FRAME_INCREMENT_SIZE_25_FPS) * FRAME_INCREMENT_SIZE_25_FPS;
      memo.push({
        ...region,
        startMs,
        endMs,
      });
      return memo;
    }
    // take previous region's endMs as startMs to ensure no gaps are created
    const prevRegion = memo[memo.length - 1];
    const startMs = prevRegion.endMs;
    // floor if it's the last item in the array to prevent extending beyond the duration of the playable video or audio
    const endMs = isLastItem
      ? region.endMs
      : Math.round(region.endMs / FRAME_INCREMENT_SIZE_25_FPS) * FRAME_INCREMENT_SIZE_25_FPS;
    memo.push({
      ...region,
      startMs,
      endMs,
    });
    return memo;
  }, [] as TrimmableRegion[]);
};
